module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/007f4d26ef0c6bad6f435640d4c6703d.gif";